import React from 'react';
import { Selection } from '@leverege/ui-redux';
import { Content } from '@leverege/ui-elements';
import ResponsiveListView from "../list/ListView.js";
import TablePagination from "../table/TablePagination.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HistoryListView(props) {
  const {
    variant = 'history',
    paginator,
    dispatch,
    rolloverKey,
    objectType,
    context,
    footerMatchContext
  } = props;
  const onOver = data => {
    dispatch(Selection.set(rolloverKey, {
      id: data.id,
      type: objectType
    }));
  };
  const onOut = () => {
    dispatch(Selection.clear(rolloverKey));
  };
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(ResponsiveListView, {
        ...props,
        context: context,
        variant: variant,
        onOver: onOver,
        onOut: onOut
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      children: /*#__PURE__*/_jsx(TablePagination, {
        context: context,
        matchContext: footerMatchContext,
        paginator: paginator
      })
    })]
  });
}